import { useStore } from "../../components/designer/Store/zustandStore";
import { useConfigurationFan } from "../../hooks/useQueries";
import ItemGrid from "../selection/ItemGrid";
import { useState, useEffect } from "react";
import { MagnifyingGlassPlusIcon, CheckIcon} from "@heroicons/react/24/outline";
import Button from "../shared/Button";
import { userStore } from "../../stores/userStore";
import DriveSelectionDiagnostics from "./DriveSelectionDiagnostics";


export default function DriveGrid({ ventilationUnitId }) {

  const [selectedUUID] = useStore((state) => [state.selectedUUID]);
  const [user] = userStore((state) => [state.user]);
  const [showDiagnostics, setShowDiagnostics] = useState(false);

  //The drive selection diagnostics expose the datalayer's internal rejection text and the
  //API behind them is only compiled into DEBUG builds, so the button is development only.
  const showDriveDiagnostics =
    process.env.NODE_ENV == "development" && user?.userGroupId == 2;

  const { fans, selectDrive } = new useConfigurationFan(selectedUUID);
  //MotorPulleySize
  const columns = [
    // {
    //   name: "Model",
    //   //selector: (row) => row?.fan?.modelName,
    //   sortable: true,
    // },

    {
      name: "Dev(%)",
      selector: (row) => row?.drive?.deviation,
      sortable: true,
    },
    {
      name: "M.Pulley",
      selector: (row) => row?.drive?.motorPulleySize,
      sortable: true,
    },

    {
      name: "F.Pulley",
      selector: (row) => row?.drive?.fanPulleySize,
      sortable: true,
    },
    {
      name: "Belt",
      selector: (row) => row?.drive?.beltLength,
      sortable: true,
    },
    {
      name: "No.Belts",
      selector: (row) => row?.drive?.numberBelts,
      sortable: true,
    },
    {
      name: "Centres",
      selector: (row) => row?.drive?.actualCentres,
      sortable: true,
    },
    // {
    //   name: "Motor",
    //   selector: (row) => row?.drive?.motorFrame,
    //   sortable: true,
    // },
    {
      name: "M.Speed",
      selector: (row) => row?.drive?.motorSpeed,
      sortable: true,
    },
    // {
    //   name: "A.Speed",
    //   selector: (row) => row?.drive?.actualFanSpeed,
    //   sortable: true,
    // },
    {
      name: "kW",
      selector: (row) => row?.drive?.motorKW,
      sortable: true,
    },
    {
      name: "Brg Life L10",
      selector: (row) => row?.drive?.operatingHoursL10,
      sortable: true,
    },
    {
      name: "Brg Life L50",
      selector: (row) => row?.drive?.operatingHoursL50,
      sortable: true,
    },
    {
      name: "",
      selector: (row) => row?.drive?.guid == fans?.drives?.activeDrive?.guid ? "" : <Button buttonSize="xs" buttoncolor={"primary"} cssclass="!rounded-md" onClick={() => selectDrive({ventilationUnitId:ventilationUnitId, fanId: fans?.guid, driveId: row?.drive?.guid , referrer: "Selector" })}>Select</Button>,
      sortable: true,
      maxWidth: "30px"  

    }
  ];

  const conditionalRowStyles = [
    {
      //when: (row) => row.velocity <= 4 && row.velocity > 2.5,
      when: (row) => row?.drive?.guid == fans?.drives?.activeDrive?.guid,
      style: {
        backgroundColor: "green",
        opacity: 0.6,
        color: "white",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },

  ];


  const getDriveItems = (vuFan) => {
    let driveItems = [];

    console.log("[DriveGrid] getDriveItems", {
      selectedUUID,
      ventilationUnitId,
      hasFan: !!vuFan,
      componentId: vuFan?.componentId,
      fanGuid: vuFan?.guid,
      fanModelName: vuFan?.fan?.modelName,
      selectedFanId: vuFan?.selectedFanId,
      hasDrives: !!vuFan?.drives,
      driveCount: vuFan?.drives?.items?.length ?? "no items array",
      activeDriveGuid: vuFan?.drives?.activeDrive?.guid,
      calculationStatus: vuFan?.calculationStatus,
      errorText: vuFan?.errorText,
    });

    if (vuFan?.drives?.items.length > 0) {
      for (let index = 0; index < vuFan.drives.items.length; index++) {
        const drive = vuFan.drives.items[index];
        driveItems.push({
          drive,
        });
      }
      return driveItems;
    }

    //returning null here makes the whole grid render nothing, so an empty
    //drive list and a failed/absent fetch look identical on screen
    console.log("[DriveGrid] no drives to show - grid will not render", {
      reason: !vuFan
        ? "fan payload is null/undefined"
        : !vuFan.drives
        ? "fan.drives is null - server never populated Drives"
        : "fan.drives.items is empty",
    });

    return null;
  };

  useEffect(() => {
    setDriveItems(getDriveItems(fans));
  },[fans]);

  function OpenDrive()
  {
    
  }

const [driveItems, setDriveItems] = useState();

  return (
    <div>
        <div className="p-3 flex flex-row items-center">
        <div>
          <h3 className="text-base font-semibold leading-6 text-gray-900">Available Drives</h3>
        </div>
        {showDriveDiagnostics && (
          <div className="ml-auto">
            <Button
              buttonSize="xs"
              buttoncolor={"primary"}
              cssclass="!rounded-md"
              onClick={() => setShowDiagnostics(true)}
            >
              Drive Selection Method
            </Button>
          </div>
        )}
      </div>

      {driveItems ? (
        <ItemGrid
          columns={columns}
          data={driveItems}
          defaultSortFieldId={2}
          conditionalRowStyles={conditionalRowStyles}
          // progressPending={resultsLoading}
          // // selectableRows
          // onSelectedRowsChange={selectedRowChangedHandler}
          pagination
        />
      ) : (
        //previously the whole section was hidden here, so an empty drive list was
        //indistinguishable from the panel failing to load
        <p className="px-3 pb-3 text-sm text-gray-500">
          {fans
            ? "No drives available for this fan and motor combination."
            : "Loading drives…"}
        </p>
      )}

      {showDriveDiagnostics && (
        <DriveSelectionDiagnostics
          open={showDiagnostics}
          setOpen={setShowDiagnostics}
        />
      )}
    </div>
  );
}
